import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function PortfolioComposition({ portfolioComposition }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     flagship_products: "b",
  //     niche_offerings: "c",
  //     add_on_services: "d",
  //     flagship_products_positive_insight: "b",
  //     flagship_products_negative_insight: "b",
  //     flagship_products_recent_development: "b",
  //     niche_offerings_positive_insight: "c",
  //     niche_offerings_negative_insight: "c",
  //     niche_offerings_recent_development: "c",
  //     add_on_services_positive_insight: "d",
  //     add_on_services_negative_insight: "d",
  //     add_on_services_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     flagship_products: "b",
  //     niche_offerings: "c",
  //     add_on_services: "d",
  //     flagship_products_positive_insight: "b",
  //     flagship_products_negative_insight: "b",
  //     flagship_products_recent_development: "b",
  //     niche_offerings_positive_insight: "c",
  //     niche_offerings_negative_insight: "c",
  //     niche_offerings_recent_development: "c",
  //     add_on_services_positive_insight: "d",
  //     add_on_services_negative_insight: "d",
  //     add_on_services_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     flagship_products: "b",
  //     niche_offerings: "c",
  //     add_on_services: "d",
  //     flagship_products_positive_insight: "b",
  //     flagship_products_negative_insight: "b",
  //     flagship_products_recent_development: "b",
  //     niche_offerings_positive_insight: "c",
  //     niche_offerings_negative_insight: "c",
  //     niche_offerings_recent_development: "c",
  //     add_on_services_positive_insight: "d",
  //     add_on_services_negative_insight: "d",
  //     add_on_services_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(portfolioComposition);
    setTabData(tableData);
  }, [portfolioComposition]);

  const tableColumns = [
    // { id: "competitor", label: "Competitor" },
    { key: "flagship_products", label: "Flagship Products" },
    { key: "niche_offerings", label: "Niche Offerings" },
    { key: "add_on_services", label: "Add-on Services" },
  ];

  return (
    <InsightTable
      title="Portfolio Composition"
      subtitle="Comparing the flagship product lines, niche offerings, and service adjacencies of top players in healthcare distribution and medical supply."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default PortfolioComposition;
